import { SodiumPlus, X25519PublicKey, X25519SecretKey } from "sodium-plus";

let sodium: SodiumPlus;

const publicKey = X25519PublicKey.from(
  Buffer.from(process.env.NEXT_PUBLIC_KEY ?? "", "hex")
);

export const encryptFormData = async (obj: any) => {
  let encryptedObject: { [key: string]: any } = {};

  for (const id in obj) {
    const encryptedData = encryptObject(obj[id].data);
    encryptedObject[id] = { ...obj[id], data: encryptedData };
  }
};

export const encryptObject = async (obj: any) => {
  let encryptedObject: { [key: string]: any } = {};

  for (const id in obj) {
    const objectData = obj[id].data;
    let encryptedData: { [key: string]: any } = {};

    if (objectData) {
      for (const dataId in objectData) {
        let encryptedString;
        const item = objectData[dataId];
        if (item.value) {
          encryptedString = await encryptString(item.value.toString());
          encryptedData[dataId] = { ...item, value: encryptedString };
        } else if (item.label) {
          encryptedString = await encryptString(item.label);
          encryptedData[dataId] = { ...item, label: encryptedString };
        }
        encryptedObject[id] = {
          ...obj[id],
          data: encryptedData,
        };
      }
    }
  }
  return encryptedObject;
};

const encryptArray = async (array: Array<any>) => {
  let encrypted = [];
  for (let i = 0; i < array.length; i++) {
    let item = array[i];
    let encryptedString;
    if (item.value) {
      encryptedString = await encryptString(item.value);
      encrypted.push({ ...item, value: encryptedString });
    } else if (item.label) {
      encryptedString = await encryptString(item.label);
      encrypted.push({ ...item, label: encryptedString });
    }
  }
  return encrypted;
};

export const encryptString = async (string: string) => {
  if (!sodium) sodium = await SodiumPlus.auto();
  const buffer = Buffer.from(string);
  let encryptedKeyData = await sodium.crypto_box_seal(buffer, publicKey);
  return JSON.stringify(encryptedKeyData.toJSON());
};

// export const decryptObject = async (data: any) => {
//   if (!sodium) sodium = await SodiumPlus.auto();
//   let decryptedData: { [key: string]: any } = {};
//   for (const key in data) {
//     const encrypted = Buffer.from(JSON.parse(data[key]));
//     let decryptedKeyData = await sodium.crypto_box_seal_open(
//       encrypted,
//       publicKey,
//       secretKey
//     );
//     let decryptedString = decryptedKeyData.toString();
//     decryptedData[key] = decryptedString;
//   }
//   return decryptedData;
// };
